'use client'

import { useAuth } from '@/lib/contexts/auth-context'
import { useEffect, useState } from 'react'

export function usePermission(permission: string | string[]): boolean {
  const { hasPermission, isLoading } = useAuth()
  const [hasAccess, setHasAccess] = useState(false)

  useEffect(() => {
    if (!isLoading) {
      if (Array.isArray(permission)) {
        setHasAccess(permission.some(p => hasPermission(p)))
      } else {
        setHasAccess(hasPermission(permission))
      }
    }
  }, [permission, hasPermission, isLoading])

  return hasAccess
}

export function useRequirePermission(
  permission: string | string[],
  redirectTo: string = '/unauthorized'
): boolean {
  const hasAccess = usePermission(permission)
  const { isLoading } = useAuth()
  
  useEffect(() => {
    if (!isLoading && !hasAccess) {
      window.location.href = redirectTo
    }
  }, [hasAccess, isLoading, redirectTo])

  return hasAccess
}